import React from 'react';
const Bookmark = ({ ...r }) => {
    return(
        <svg 
            width="24" 
            height="25"     
            viewBox="0 0 24 25"     
            fill="none"     
            xmlns="http://www.w3.org/2000/svg"
            { ...r }>
                <path d="M5 2.99866H19C19.2652 2.99866 19.5196 3.10401 19.7071 3.29155C19.8946 3.47909 20 3.73344 20 3.99866V23.1417C20.0001 23.2311 19.9763 23.3189 19.9309 23.3959C19.8855 23.473 19.8204 23.5364 19.7421 23.5797C19.6639 23.623 19.5755 23.6446 19.4861 23.6421C19.3968 23.6396 19.3097 23.6132 19.234 23.5657L12 19.0287L4.766 23.5647C4.69037 23.6122 4.60339 23.6386 4.5141 23.6411C4.42482 23.6436 4.33649 23.6222 4.2583 23.579C4.1801 23.5358 4.11491 23.4725 4.06948 23.3956C4.02406 23.3187 4.00007 23.231 4 23.1417V3.99866C4 3.73344 4.10536 3.47909 4.29289 3.29155C4.48043 3.10401 4.73478 2.99866 5 2.99866ZM18 4.99866H6V20.4307L12 16.6697L18 20.4307V4.99866Z" fill="#272727"/>
        </svg>
    );}
  
  export default Bookmark;